export default {
  translations: {
    da: {
      months: {
        original: [
          'Januar',
          'Februar',
          'Marts',
          'April',
          'Maj',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'December'
        ],
        abbr: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'Maj',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Okt',
          'Nov',
          'Dec'
        ]
      },
      days: ['Sø', 'Ma', 'Ti', 'On', 'To', 'Fr', 'Lø']
    },

    en: {
      months: {
        original: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        abbr: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ]
      },
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    },

    es: {
      months: {
        original: [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ],
        abbr: [
          'Ene',
          'Feb',
          'Mar',
          'Abr',
          'May',
          'Jun',
          'Jul',
          'Ago',
          'Sep',
          'Oct',
          'Nov',
          'Dic'
        ]
      },
      days: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sab']
    },

    fi: {
      months: {
        original: [
          'tammikuu',
          'helmikuu',
          'maaliskuu',
          'huhtikuu',
          'toukokuu',
          'kesäkuu',
          'heinäkuu',
          'elokuu',
          'syyskuu',
          'lokakuu',
          'marraskuu',
          'joulukuu'
        ],
        abbr: [
          'tammi',
          'helmi',
          'maalis',
          'huhti',
          'touko',
          'kesä',
          'heinä',
          'elo',
          'syys',
          'loka',
          'marras',
          'joulu'
        ]
      },
      days: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la']
    },

    fr: {
      months: {
        original: [
          'Janvier',
          'Février',
          'Mars',
          'Avril',
          'Mai',
          'Juin',
          'Juillet',
          'Août',
          'Septembre',
          'Octobre',
          'Novembre',
          'Décembre'
        ],
        abbr: [
          'Jan',
          'Fév',
          'Mar',
          'Avr',
          'Mai',
          'Jui',
          'Juil',
          'Aoû',
          'Sep',
          'Oct',
          'Nov',
          'Déc'
        ]
      },
      days: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam']
    },

    hr: {
      months: {
        original: [
          'Siječanj',
          'Veljača',
          'Ožujak',
          'Travanj',
          'Svibanj',
          'Lipanj',
          'Srpanj',
          'Kolovoz',
          'Rujan',
          'Listopad',
          'Studeni',
          'Prosinac'
        ],
        abbr: [
          'Sij',
          'Velj',
          'Ožu',
          'Tra',
          'Svi',
          'Lip',
          'Srp',
          'Kol',
          'Ruj',
          'Lis',
          'Stu',
          'Pro'
        ]
      },
      days: ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub']
    },

    it: {
      months: {
        original: [
          'Gennaio',
          'Febbraio',
          'Marzo',
          'Aprile',
          'Maggio',
          'Giugno',
          'Luglio',
          'Agosto',
          'Settembre',
          'Ottobre',
          'Novembre',
          'Dicembre'
        ],
        abbr: [
          'Gen',
          'Feb',
          'Mar',
          'Apr',
          'Mag',
          'Giu',
          'Lug',
          'Ago',
          'Set',
          'Ott',
          'Nov',
          'Dic'
        ]
      },
      days: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab']
    },

    nl: {
      months: {
        original: [
          'Januari',
          'Februari',
          'Maart',
          'April',
          'Mei',
          'Juni',
          'Juli',
          'Augustus',
          'September',
          'Oktober',
          'November',
          'December'
        ],
        abbr: [
          'Jan',
          'Feb',
          'Maa',
          'Apr',
          'Mei',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Okt',
          'Nov',
          'Dec'
        ]
      },
      days: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za']
    },

    de: {
      months: {
        original: [
          'Januar',
          'Februar',
          'März',
          'April',
          'Mai',
          'Juni',
          'Juli',
          'August',
          'September',
          'Oktober',
          'November',
          'Dezember'
        ],
        abbr: [
          'Jan',
          'Feb',
          'Mär',
          'Apr',
          'Mai',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Okt',
          'Nov',
          'Dez'
        ]
      },
      days: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.']
    },

    'pt-br': {
      months: {
        original: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro'
        ],
        abbr: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez'
        ]
      },
      days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']
    },

    vi: {
      months: {
        original: [
          'Tháng 1',
          'Tháng 2',
          'Tháng 3',
          'Tháng 4',
          'Tháng 5',
          'Tháng 6',
          'Tháng 7',
          'Tháng 8',
          'Tháng 9',
          'Tháng 10',
          'Tháng 11',
          'Tháng 12'
        ],
        abbr: [
          'T 01',
          'T 02',
          'T 03',
          'T 04',
          'T 05',
          'T 06',
          'T 07',
          'T 08',
          'T 09',
          'T 10',
          'T 11',
          'T 12'
        ]
      },
      days: ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7']
    },

    zh: {
      months: {
        original: [
          '一月',
          '二月',
          '三月',
          '四月',
          '五月',
          '六月',
          '七月',
          '八月',
          '九月',
          '十月',
          '十一月',
          '十二月'
        ],
        abbr: [
          '一月',
          '二月',
          '三月',
          '四月',
          '五月',
          '六月',
          '七月',
          '八月',
          '九月',
          '十月',
          '十一月',
          '十二月'
        ]
      },
      days: ['日', '一', '二', '三', '四', '五', '六']
    },

    ja: {
      months: {
        original: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        abbr: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ]
      },
      days: ['日', '月', '火', '水', '木', '金', '土']
    },

    he: {
      months: {
        original: [
          'ינואר',
          'פברואר',
          'מרץ',
          'אפריל',
          'מאי',
          'יוני',
          'יולי',
          'אוגוסט',
          'ספטמבר',
          'אוקטובר',
          'נובמבר',
          'דצמבר'
        ],
        abbr: [
          'ינו',
          'פבר',
          'מרץ',
          'אפר',
          'מאי',
          'יונ',
          'יול',
          'אוג',
          'ספט',
          'אוק',
          'נוב',
          'דצמ'
        ]
      },
      days: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']
    },

    cs: {
      months: {
        original: [
          'leden',
          'únor',
          'březen',
          'duben',
          'květen',
          'červen',
          'červenec',
          'srpen',
          'září',
          'říjen',
          'listopad',
          'prosinec'
        ],
        abbr: [
          'led',
          'úno',
          'bře',
          'dub',
          'kvě',
          'čer',
          'čec',
          'srp',
          'zář',
          'říj',
          'lis',
          'pro'
        ]
      },
      days: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so']
    },

    ru: {
      months: {
        original: [
          'Январь',
          'Февраль',
          'Март',
          'Апрель',
          'Май',
          'Июнь',
          'Июль',
          'Август',
          'Сентябрь',
          'Октябрь',
          'Ноябрь',
          'Декабрь'
        ],
        abbr: [
          'Янв',
          'Февр',
          'Март',
          'Апр',
          'Май',
          'Июнь',
          'Июль',
          'Авг',
          'Сент',
          'Окт',
          'Нояб',
          'Дек'
        ]
      },
      days: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
    },

    sv: {
      months: {
        original: [
          'Januari',
          'Februari',
          'Mars',
          'April',
          'Maj',
          'Juni',
          'Juli',
          'Augusti',
          'September',
          'Oktober',
          'November',
          'December'
        ],
        abbr: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'Maj',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ]
      },
      days: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör']
    },

    th: {
      months: {
        original: [
          'มกราคม',
          'กุมภาพันธ์',
          'มีนาคม',
          'เมษายน',
          'พฤษภาคม',
          'มิถุนายน',
          'กรกฎาคม',
          'สิงหาคม',
          'กันยายน',
          'ตุลาคม',
          'พฤศจิกายน',
          'ธันวาคม'
        ],
        abbr: [
          'ม.ค.',
          'ก.พ.',
          'มี.ค.',
          'เม.ย.',
          'พ.ค.',
          'มิ.ย.',
          'ก.ค.',
          'ส.ค.',
          'ก.ย.',
          'ต.ค.',
          'พ.ย.',
          'ธ.ค.'
        ]
      },
      days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส']
    },

    ro: {
      months: {
        original: [
          'Ianuarie',
          'Februarie',
          'Martie',
          'Aprilie',
          'Mai',
          'Iunie',
          'Iulie',
          'August',
          'Septembrie',
          'Octombrie',
          'Noiembrie',
          'Decembrie'
        ],
        abbr: [
          'Ian',
          'Feb',
          'Mar',
          'Apr',
          'Mai',
          'Iun',
          'Iul',
          'Aug',
          'Sep',
          'Oct',
          'Noi',
          'Dec'
        ]
      },
      days: ['D', 'L', 'Ma', 'Mi', 'J', 'V', 'S']
    },

    'sl-si': {
      months: {
        original: [
          'Januar',
          'Februar',
          'Marec',
          'April',
          'Maj',
          'Junij',
          'Julij',
          'Avgust',
          'September',
          'Oktober',
          'November',
          'December'
        ],
        abbr: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'Maj',
          'Jun',
          'Jul',
          'Avg',
          'Sep',
          'Okt',
          'Nov',
          'Dec'
        ]
      },
      days: ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob']
    }
  }
};
